import React from "react";
import {
  Grid,
  IconButton,
  Container,
  Typography,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import InstagramIcon from "@material-ui/icons/Instagram";
import { useTranslation } from "react-i18next";
import { EmailOutlined, PhoneOutlined, LinkOutlined } from "@material-ui/icons";
import wbLogo from "assets/wbLogo.svg";
// import { GlobalOutlined, PhoneOutlined, MessageOutlined } from "@ant-design/icons";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  footer: {
    marginTop: "auto",
    backgroundColor: "#303030",
    minHeight: "40px",
    padding: "20px",
    // position: "absolute",

  },
  footerText: {
    textAlign: "center",
    // marginTop: '8px',
    color: "#ffffff",
    fontFamily: "Poppins",
  },
  companyText: {
    marginTop: "8px",
    color: "#ffffff",
  },
  socialIcon: {
    color: "#ffffff",
  },
});

const Footer = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleFacebook = () => {
    window.open("https://web.facebook.com/BRDBank", "_blank");
  };

  const handleTwitter = () => {
    window.open(
      "https://twitter.com/BRDbank/status/1072871791130013696?s=20",
      "_blank"
    );
  };

  const handleLinkedin = () => {
    window.open(
      "https://www.linkedin.com/company/brdbank/mycompany/",
      "_blank"
    );
  };

  const isMobile = window.innerWidth <= 768;

  const handleInstagram = () => {
    window.open("https://www.instagram.com/brdbank/?hl=en", "_blank");
  };
  return (
		<div className={classes.footer}>
			<Container>
				<Grid container justifyContent={isMobile ? 'center' : 'space-between'}>
					{!isMobile && (
						<Grid item>
							<Grid container direction='column'>
								<Grid item className={classes.companyText}>
									{t('sponsored-by')}
								</Grid>
							</Grid>
						</Grid>
					)}
					<Grid item>
						<Grid container direction='column'>
							<Grid item className={classes.companyText}>
								<a
									className='link-inherit'
									href='https://www.brd.rw/'
									target='_blank'
								>
									{t('developed-by')}{' '}
								</a>
							</Grid>
							<Grid container justifyContent='center' item>
								<IconButton
									onClick={handleFacebook}
									className={classes.socialIcon}
								>
									<FacebookIcon />
								</IconButton>
								<IconButton
									onClick={handleTwitter}
									className={classes.socialIcon}
								>
									<TwitterIcon />
								</IconButton>
								<IconButton
									onClick={handleLinkedin}
									className={classes.socialIcon}
								>
									<LinkedInIcon />
								</IconButton>
								<IconButton
									onClick={handleInstagram}
									className={classes.socialIcon}
								>
									<InstagramIcon />
								</IconButton>
							</Grid>
						</Grid>
					</Grid>
					{!isMobile && (
						<Grid item className={classes.companyText}>
							<label className='text-light'>{t('contact')}</label>
							<div className='mt-2'>
								<EmailOutlined style={{ color: '#FFFFFF' }} />
								BRD:
								<a href='mailto: rhfp@brd.rw' className='text-light px-2'>
									rhfp@brd.rw
								</a>
							</div>
							<div className='mt-2'>
								<EmailOutlined style={{ color: '#FFFFFF' }} />
								RHA:
								<a
									href='mailto: affordablehousingprogram@rha.gov.rw'
									className='text-light px-2'
								>
									affordablehousingprogram@rha.gov.rw
								</a>
							</div>
							{/* <div className='mt-2'>
								<PhoneOutlined style={{ color: '#FFFFFF' }} />
								<a href='tel: 252576569' className='text-light px-2'>
									252 576 569
								</a>
							</div> */}
							<div className='mt-2'>
								<LinkOutlined style={{ color: '#FFFFFF' }} />
								<a
									className='link-inherit px-2'
									href='https://www.rha.gov.rw/'
									target='_blank'
								>
									Rwanda Housing Authority
								</a>
							</div>
						</Grid>
					)}
				</Grid>
				<Divider style={{ color: '#ffffff' }} />
				<Typography className={classes.footerText}>
					Copyright &copy; 2021 - {new Date().getFullYear()}
				</Typography>
			</Container>
		</div>
	);
};

export default Footer;
